import React from 'react';
import PropTypes from 'prop-types';

function getClassName(desktopOnly, mobileOnly) {
  if (desktopOnly && !mobileOnly) {
    return 'desktop';
  }

  if (mobileOnly && !desktopOnly) {
    return 'mobile';
  }

  return '';
}

const style = { flex: '1 1 auto' };

export default function Spacer({ className, desktopOnly, mobileOnly }) {
  return (
    <i style={style} className={`${className} ${getClassName(desktopOnly, mobileOnly)}`} />
  );
}

Spacer.propTypes = {
  className: PropTypes.string,
  desktopOnly: PropTypes.bool,
  mobileOnly: PropTypes.bool
};

Spacer.defaultProps = {
  className: '',
  desktopOnly: false,
  mobileOnly: false
};
